export default __webpack_public_path__ + "static/media/heart-solid.70b72c45.svg";